/* eslint react/display-name: 0 */

import Head from 'next/head';
import React from 'react';

interface HeadProps {
  title?: string;
  description?: string;
  canonical?: string;
  ogURL?: string;
  ogImg?: string;
  twImg?: string;
  pathname?: string;
  favicon?: string;
  noFollow?: boolean;
}

const SiteHead: React.FC<HeadProps> = ({
  title,
  description,
  canonical,
  ogURL,
  ogImg,
  twImg,
  pathname,
  favicon,
  noFollow,
}) => {
  const path = favicon ? `product/${favicon}/` : '';

  return (
    <Head>
      <link rel="manifest" href="/static/global/favicon/site.webmanifest" />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={`/static/global/favicon/${path}favicon-32x32.png`}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={`/static/global/favicon/${path}favicon-16x16.png`}
      />
      <link rel="shortcut icon" href={`/static/global/favicon/${path}favicon.ico`} />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`/static/global/favicon/${path}apple-touch-icon.png`}
      />
      <link rel="mask-icon" href="/static/global/favicon/safari-pinned-tab.svg" color="#5bbad5" />
      <meta name="msapplication-TileColor" content="#000000" />
      <meta name="theme-color" content="#000000" />

      <meta name="description" content={description} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@scaleapi" />
      <meta name="twitter:creator" content="@scaleapi" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twImg} />

      <meta property="og:url" content={ogURL || `https://scale.com${pathname}`} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImg} />

      <meta name="viewport" content="initial-scale=1, width=device-width" />

      {canonical && <link rel="canonical" href={canonical} />}

      <title>{title}</title>

      {noFollow ? (
        <meta name="robots" content="noindex" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
    </Head>
  );
};

SiteHead.defaultProps = {
  title: 'Scale AI: The Data Platform for AI',
  description:
    'Trusted by world class companies, Scale delivers high quality training data for AI applications such as self-driving cars, mapping, AR/VR, robotics, and more.',
  canonical: undefined,
  ogImg: 'https://scale.com/static/global/facebook-card.png',
  twImg: 'https://scale.com/static/global/twitter-card.png',
  favicon: undefined,
  noFollow: false,
};

export default SiteHead;
